export enum CallInsightReviewStatus {
  Pending = 'pending',
  Confirmed = 'confirmed',
  Discarded = 'discarded',
}
